import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { getSettingList, updateStatus } from "../../store/ducks/mallSetting/actions";
import { filterErrorHandler } from "../../hoc/Shared/utility";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import MallSettingListing from "./MallSettingListing";
import UpdownArrowWhite from "../../assets/images/updown-arrow-white.png";

class MallSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',
            data: [],
            permission: []
        }
    }
    
    componentDidMount() {
        const data = this.fetchData();
        this.props.getSettingList(data);
    }
    
    shouldComponentUpdate(nextProps, nextState) {        
    	const { t } = this.props;

        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            this.setState({ permission: this.props.currentPermission });            
        }        
        
        if (nextProps.mall_setting_list !== undefined && nextProps.mall_setting_list !== this.props.mall_setting_list) {            
            if (nextProps.mall_setting_list.responseCode === 200 && nextProps.mall_setting_list.msgType === 'success') {                        
                this.setState({
                    data: nextProps.mall_setting_list.data.result.row,
                    totalRecords: nextProps.mall_setting_list.data.result.pagination.total_record,
                    loading: false
                })                
            }
            else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0
                }, () => {
                    filterErrorHandler(nextProps.mall_setting_list.message);
                });
            }
        }

        if (nextProps.update_status !== this.props.update_status && nextProps.update_status !== undefined) 
        {
            if (nextProps.update_status.responseCode === 200 && nextProps.update_status.msgType === 'success') 
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then(() => {
                    this.refreshHandler();
                });
            } else {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.update_status.message);
                });
                Swal.close();
            }
        }
        return true;
    }
    
    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage });
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);

        return listingArr;
    }

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettingList(listingArr);
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettingList(listingArr);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    };

    updateStatusHandler = (event) => 
    {
        // console.log(event.target.id+' | '+event.target.value);
        // this.loadingHandler();
        let data = {};
        data.id = event.target.id;
        data.status = event.target.value;
        // console.log(data);
        this.props.updateStatus(data);
    }

    settingValueFormatter = (cell, row) => {
        const { t } = this.props; 
        let activeStatus = Number(row.status);
        let stCls = activeStatus === 1 ? "active" : "inactive";
    
        let actionVal = this.state.permission.includes("mall_setting_update_status") 
            ? (
                <div className="select-input">
                    <select
                        className={`form-control datatable-select datatable-select-${stCls}`}
                        id={row.id}
                        name={row.id}
                        onChange={(event) => this.updateStatusHandler(event)}
                        value={activeStatus === null ? 0 : activeStatus}
                    >
                        <option value="1">{t("global.active")}</option>
                        <option value="0">{t("global.inactive")}</option>
                    </select>
                    <img className="updown-icon" src={UpdownArrowWhite} alt="Up Down White Arrow" />
                </div>
            ) : (
                <span className={`badge-pill badge-${activeStatus === 1 ? "success" : "danger"}`}>
                    {activeStatus === 1 ? t("global.active") : t("global.inactive")}
                </span>
            );
    
        return actionVal;                
    };    

    refreshHandler = () =>
    {
        this.setState({
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        }, ()=> {
            const listingArr = this.fetchData();
            this.props.getSettingList(listingArr);
        });
    }    
    
    render() {
        const { t } = this.props;
        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("mall-setting.slug"), dataField: "slug", sort: true, onSort: this.onSort },
            { text: t("mall-setting.status"), dataField: "status", formatter: this.settingValueFormatter, headerStyle: { width: '250px' } },
        ]
        let data = this.state.data.map((val, idx) => {
            return {
                no: idx,
                id: val.id,
                slug: val.slug,
                status: val.status
            }
        });
        
        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <MallSettingListing
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}
                        data={data}
                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        loading={this.state.loading}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        mall_setting_list: state.mallSetting.mall_setting_list,
        update_status: state.mallSetting.update_mall_setting_status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getSettingList: (data) => dispatch(getSettingList(data)),
        updateStatus: (data) => dispatch(updateStatus(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MallSetting));
